"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ChartMouseEvent = (function () {
    function ChartMouseEvent() {
    }
    return ChartMouseEvent;
}());
exports.ChartMouseEvent = ChartMouseEvent;
/**
 * @deprecated Use ChartMouseOverEvent instead
 */
var MouseOverEvent = (function (_super) {
    __extends(MouseOverEvent, _super);
    function MouseOverEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MouseOverEvent;
}(ChartMouseEvent));
exports.MouseOverEvent = MouseOverEvent;
var ChartMouseOverEvent = (function (_super) {
    __extends(ChartMouseOverEvent, _super);
    function ChartMouseOverEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChartMouseOverEvent;
}(ChartMouseEvent));
exports.ChartMouseOverEvent = ChartMouseOverEvent;
var ChartMouseOutEvent = (function (_super) {
    __extends(ChartMouseOutEvent, _super);
    function ChartMouseOutEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChartMouseOutEvent;
}(ChartMouseEvent));
exports.ChartMouseOutEvent = ChartMouseOutEvent;



//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/node_modules/ng2-google-charts/google-chart/chart-mouse-event.js
// module id = ../../../../ng2-google-charts/google-chart/chart-mouse-event.js
// module chunks = vendor